<div class="printer-picker">
  @switch (state()) { @case ('loading') {
  <div class="pp-empty">
    <i class="pi pi-spin pi-spinner"></i>
    <span>{{ flow.t('printers_loading', 'Printerlar qidirilmoqda...') }}</span>
  </div>
  } @case ('noAgent') {
  <div class="pp-empty pp-empty--warn">
    <i class="pi pi-exclamation-triangle"></i>
    <div class="pp-empty__text">
      <b
        >{{ flow.t('print_agent_not_running', 'Chop etish dasturi ishlamayapti')
        }}</b
      >
      <span
        >{{ flow.t( 'print_agent_not_running_hint', "Print Agent o'rnatilmagan
        yoki yopilgan. Dastursiz chop etib bo'lmaydi." ) }}</span
      >
    </div>
    <div class="pp-empty__actions">
      <p-button
        size="small"
        [label]="flow.t('print_agent_how_to_install', 'Qanday o\'rnatiladi')"
        icon="pi pi-question-circle"
        (click)="flow.openGuide()"
      />
      <p-button
        size="small"
        severity="secondary"
        [outlined]="true"
        icon="pi pi-refresh"
        [label]="flow.t('print_agent_recheck', 'Qayta tekshirish')"
        [loading]="refreshing()"
        (click)="refresh()"
      />
    </div>
  </div>
  } @case ('noPrinters') {
  <div class="pp-empty pp-empty--warn">
    <i class="pi pi-print"></i>
    <div class="pp-empty__text">
      <b
        >{{ flow.t('printer_not_connected', 'Kompyuteringizga printer
        ulanmagan') }}</b
      >
      <span
        >{{ flow.t( 'printer_not_connected_hint', "Printerni USB yoki tarmoq
        orqali ulang va Windows'da o'rnatilganini tekshiring. PDF kabi virtual
        printerlar ko'rsatilmaydi." ) }}</span
      >
    </div>
    <div class="pp-empty__actions">
      <p-button
        size="small"
        severity="secondary"
        [outlined]="true"
        icon="pi pi-refresh"
        [label]="flow.t('refresh', 'Yangilash')"
        [loading]="refreshing()"
        (click)="refresh()"
      />
    </div>
  </div>
  } @case ('ready') {
  <div class="pp-head">
    <span class="pp-title"
      >{{ flow.t('choose_printer', 'Printer tanlang') }}</span
    >
    <p-button
      size="small"
      [text]="true"
      icon="pi pi-refresh"
      [label]="flow.t('refresh', 'Yangilash')"
      [loading]="refreshing()"
      (click)="refresh()"
    />
  </div>

  <ul class="pp-list" role="radiogroup">
    @for (printer of printers(); track printer.name) { @let view =
    statusView(printer);
    <li>
      <button
        type="button"
        role="radio"
        class="pp-row"
        [class.pp-row--selected]="printer.name === selected()"
        [class.pp-row--blocked]="isBlocked(printer)"
        [attr.aria-checked]="printer.name === selected()"
        [disabled]="isBlocked(printer)"
        (click)="choose(printer)"
      >
        <span class="pp-radio"></span>
        <span class="pp-name">
          {{ printer.name }} @if (printer.isDefault) {
          <span class="pp-badge"
            >{{ flow.t('printer_default', 'Standart') }}</span
          >
          } @if (printer.isNetwork) {
          <i
            class="pi pi-wifi pp-net"
            [pTooltip]="flow.t('printer_network', 'Tarmoq printeri')"
          ></i>
          }
        </span>
        <span class="pp-status" [attr.data-tone]="view.tone">
          <span class="pp-dot"></span>{{ view.label }}
        </span>
      </button>
    </li>
    }
  </ul>

  <div class="pp-foot">
    @if (!selectedPrinter()) {
    <span class="pp-note--warn"
      >{{ flow.t('printer_none_available', "Ishlaydigan printer yo'q") }}</span
    >
    } @else if (!canPrint()) {
    <span class="pp-note--warn"
      >{{ flow.t('printer_selected_unavailable', 'Tanlangan printer hozir
      ishlamayapti, boshqasini tanlang') }}</span
    >
    }
  </div>
  } } @if (outdated() && state() !== 'noAgent') {
  <div class="pp-outdated">
    <i class="pi pi-info-circle"></i>
    <span
      >{{ flow.t( 'print_agent_outdated', "Print Agent'ning eski versiyasi
      o'rnatilgan. Printer holati to'liq ko'rinmasligi mumkin." ) }}</span
    >
    <a [href]="config.downloadUrl" [attr.download]="config.fileName"
      >{{ flow.t('print_agent_update', 'Yangisini yuklab olish') }}</a
    >
  </div>
  }
</div>
